import { render, staticRenderFns } from "./GestionSocial.vue?vue&type=template&id=4ea47029&scoped=true&lang=pug&"
import script from "./GestionSocial.vue?vue&type=script&lang=js&"
export * from "./GestionSocial.vue?vue&type=script&lang=js&"
import style0 from "./GestionSocial.vue?vue&type=style&index=0&id=4ea47029&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea47029",
  null
  
)

export default component.exports